import React from 'react'
import FormProvider from './Context'
import FormWrapper from './Wrapper'

const QualificationForm: React.FC = () => {
  return (
    <FormProvider>
      <FormWrapper />
    </FormProvider>
  )
}

export default QualificationForm
